import { useContext, useMemo, type Context } from "react";
import { mapObject, type Store } from "./common";
import {
  type ConsumerSetterConfig,
  type ConsumerSetterResult,
  type ParametersExceptFirst,
  type StoreValue,
} from "./types";

export function makeUseConsumerSetters<
  TStoreBaseValue,
  TConsumerSetterConfig extends ConsumerSetterConfig<TStoreBaseValue>,
>(context: Context<Store<StoreValue<TStoreBaseValue>>>, setterConfig: TConsumerSetterConfig) {
  return function useConsumerSetters() {
    const store = useContext(context);
    return useMemo(
      () =>
        mapObject(
          setterConfig,
          (_, setterConfigFn) =>
            (...args: ParametersExceptFirst<typeof setterConfigFn>) => {
              store.set((draft) => setterConfigFn(draft.base, ...args));
            },
        ),
      [],
    ) as ConsumerSetterResult<TStoreBaseValue, TConsumerSetterConfig>;
  };
}
